import { OptionsIcon } from "assets/icons/OptionsIcon";
import { ModalDelete } from "components/ModalDelete/ModalDelete";
import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { ReactNode, useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";

interface Props {
  elemento: DiseñoCurricularI;
  renderActions?: (elemento: DiseñoCurricularI) => ReactNode;
  // handleShowDetailModal: (id: number | string) => void,
  // handleDelete: (id: number | string) => void,
  // handleEdit: (notificacion: NotificacionI) => void,
}

export const DiseñosCurricularesRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`DiseñosCurricularesTable-${elemento.id}`}>
        <td>{elemento.id}</td>
        <td>{elemento.nombre}</td>
        <td>{elemento.descripcion}</td>
        <td>{formatDate.stringDate(elemento.fechaPublicacion)}</td>
        <td>
          <Badge
            bg={"none"}
            style={{
              color: `${elemento?.estado?.textColor}`,
              backgroundColor: `${elemento?.estado?.backgroundColor}`,
              borderColor: `${elemento?.estado?.borderColor}`,
            }}
          >
            {elemento?.estado?.nombre}
          </Badge>
        </td>
        <td>{elemento?.nivel?.nombre}</td>
        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
